import {useLazyQuery} from '@apollo/client'
import {GET_TPV_CONTRACT_FILES} from '../../../../../utils/GraphQLAPI'
import {Col, Row, Spinner} from 'react-bootstrap'
import PdfViewer from '../../../../sharedComponent/viewer/PDFViewer'
import { renderFileHeader } from '../../../../../utils/Contract/ContractUtils'
import { GLOBAL_CONSTANTS } from '../../../../../utils/GlobalConstants'
import { useEffect } from 'react'
const ContractTPVReports = ({tpvId}: {tpvId: string}) => {
  const[getTPVContractFiles,{loading, data, error}] = useLazyQuery(GET_TPV_CONTRACT_FILES, {
    variables: {
      tpvId: tpvId,
    },
    fetchPolicy:GLOBAL_CONSTANTS.networkOnly
  })
  useEffect(()=>{
    getTPVContractFiles()
  },[])
  if (loading) {
    return (
      <div className='text-center'>
        <Spinner animation='border' className='text-gray-600' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </Spinner>
      </div>
    )
  }
  if (error) {
    return (
      <div className='text-center alert alert-danger mt-5'>
        <h4 className='fs7'> {error?.message}</h4>
      </div>
    )
  }
  return (
    <div className='tab d-flex flex-row justify-content-between'>
      <Row className='w-100'>
        {
          data?.getTpvContractFilesByTpvId?.contractUrl&&(<Col lg={6} key={data?.getTpvContractFilesByTpvId?.contractUrl} className='mb-3'>
          <p className='fs-4 fw-bold my-5'>Contract</p>
          <PdfViewer url={data?.getTpvContractFilesByTpvId?.contractUrl} previewSettings={GLOBAL_CONSTANTS.previewSettings} />
        </Col>)
        }
        {data?.getTpvContractFilesByTpvId?.productFiles?.length ? (
          data?.getTpvContractFilesByTpvId?.productFiles?.filter((urls:any)=>urls.position!==3)?.map((url: any) => (
            <Col lg={6} key={url.fileUrl} className='mb-3'>
              <p className='fs-4 fw-bold my-5'>{renderFileHeader(url?.position)}</p>
              <PdfViewer url={url.fileUrl} previewSettings={GLOBAL_CONSTANTS.previewSettings} />
            </Col>
          ))
        ) : (
          <div className='text-center'>No files found</div>
        )}
      </Row>
    </div>
  )
}
export default ContractTPVReports
